import axiosTokenInstance from "services/api/backoffice";
import { GET_SALES_DAILY, GET_SALES_DAILY_ERROR } from "_models/redux/types";

// Action function
export const getSalesDailyAction = (params) => async (dispatch) => {
    const { from_time, to_time } = params || {};

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/reports/sim-purchase/by-product-daily?from_time=${from_time}&to_time=${to_time}`
        );

        const { data, status } = response || {};

        dispatch({
            method: "get",
            payload: data || {},
            status: status || {},
            type: GET_SALES_DAILY,
        });
    } catch (e) {
        console.error(e);

        const { response } = e || {};
        const { status } = response || {};

        dispatch({
            method: "get",
            payload: e || {},
            status: status,
            type: GET_SALES_DAILY_ERROR,
        });
    }
};
